import { useState, useRef, useEffect } from 'react';

export default function Home() {
  const [q3Answered, setQ3Answered] = useState(false);
  const couponRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (q3Answered && couponRef.current) {
      setTimeout(() => {
        couponRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [q3Answered]);

  return (
    <div className="bg-white min-h-screen">
      {/* 冒頭セクション */}
      <section className="max-w-2xl mx-auto px-4 pt-6 pb-1">
        {/* PR表記 */}
        <p className="text-xs text-gray-600 mb-3">PR:ノミネーション</p>

        {/* 期間限定帯 */}
        <div className="py-3 px-4 mb-4" style={{ backgroundColor: '#F4547A' }}>
          <p className="text-center font-bold text-lg">
            <span className="text-white">\好条件で稼ぎたい人必見！/</span>
          </p>
        </div>

        {/* メイン見出し */}
        <div className="text-center mb-2">
          <p className="text-2xl md:text-4xl font-bold leading-relaxed mb-2">
            <span className="text-3xl md:text-5xl text-red-600">有名店多数掲載！</span>
          </p>
          <p className="text-xl md:text-3xl font-bold mb-2">
            今話題の夜職特化の転職アプリ
          </p>
          <p className="text-2xl md:text-4xl font-bold text-red-600">
            実際に使ってみた話
          </p>
        </div>
      </section>

      {/* ビフォーアフターセクション */}
      <section className="max-w-2xl mx-auto px-4 pt-2 pb-2">
        <div className="mb-6">
          <div className="w-full aspect-[4/3] bg-gray-200 rounded-lg shadow-md overflow-hidden">
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/721c499ec9f078a1b43a1ffbaee93752.jpeg" 
              alt="効果画像" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* 下矢印 */}
        <div className="flex flex-col items-center gap-2 mb-6">
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce"></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </section>

      {/* 漫画パート */}
      <section className="max-w-2xl mx-auto px-4 pt-2 pb-6">
        {/* 漫画01 */}
        <div className="mb-5">
          <div className="text-center mb-4">
            <p className="text-base leading-relaxed font-bold">
              当時の私はガールズバー勤務<br />
              仕事は大変なのに時給は上がらない日々・・・
            </p>
          </div>
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/8a7ee7cc48c8accd9108dc02b75cfa7f.jpeg" 
              alt="漫画01" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        {/* 漫画02 */}
        <div className="mb-5">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/f8b32d86a04c03e8a06e5760e363e8c4.webp" 
              alt="漫画02" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        {/* 漫画03 */}
        <div className="mb-5">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/fb76139e32dd3f1994b266fef146e878.webp" 
              alt="漫画03" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        {/* 漫画04 */}
        <div className="mb-5">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/e2783b29ec9a159d1635d474eea2dca8.webp" 
              alt="漫画04" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        {/* 漫画05 */}
        <div className="mb-5">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/86d3c666515124c75134942ada8bed48.webp" 
              alt="漫画05" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>
      </section>

      {/* 商品明示セクション */}
      <section className="max-w-2xl mx-auto px-4 py-6">
        <p className="text-lg text-center mb-2">そう友人が教えてくれた</p>
        <p className="text-lg text-center mb-4">スカウトサービスの正体が…</p>
        
        <h2 className="text-3xl font-bold text-center text-red-600 mb-6">
          "Nomination"でした!
        </h2>

        <div className="mb-6">
          <img 
            src="https://storage.readdy-site.link/project_files/3733c7d9-a775-4137-85cc-35dccb60b12e/07474988-118a-4ac8-83d2-ad6b32667387_nomination_FV.png?v=8c2f99dcdd75fb939d98780b78543a77" 
            alt="ベルミス カラープラス" 
            className="w-full rounded-lg shadow-lg"
          />
        </div>

        <p className="text-xl font-bold text-center mb-2">
          「<span className="bg-yellow-200">自分にあった店が見つかる</span>!」と
        </p>
        <p className="text-xl font-bold text-center mb-6">
          \有名キャバクラ嬢達からも話題に/
        </p>

        <div className="mb-6">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/a977f5bff5baeb265862a91783ffea6e.webp" 
              alt="インテグラルライン" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        {/* 下矢印 */}
        <div className="flex flex-col items-center gap-2 mb-6">
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce"></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </section>

      {/* 漫画パート続き */}
      <section className="max-w-2xl mx-auto px-4 py-6">
        {/* 漫画07 */}
        <div className="mb-5">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/ffcc93832b9f28a4d3b832869b70f755.jpeg" 
              alt="漫画07" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        <div className="mb-6">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/0d8128b14cf91aa822736f4e44b07ef9.jpeg" 
              alt="追加画像" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>

        <p className="text-xl font-bold text-center mb-4">し・か・も!</p>
        <p className="text-lg text-center mb-2">登録後は</p>
        <p className="text-lg text-center mb-4">
          オファーが届くまで待つだけでOKだからすごい楽!
        </p>

        <p className="text-lg text-center mb-2">さらに、ブロック機能もあるから</p>
        <p className="text-xl font-bold text-center mb-6 text-red-600">
          セキュリティ面も安心♪
        </p>

        <div className="mb-6">
          <div className="relative w-full" style={{ paddingBottom: '125%' }}>
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/e9688925eb04d3fe6f0aa3bd60eff24f.jpeg" 
              alt="追加画像" 
              className="absolute inset-0 w-full h-full object-contain"
            />
          </div>
        </div>
      </section>

      {/* 喜びの声セクション */}
      <section className="max-w-2xl mx-auto px-4 py-6 bg-gray-50">
        <h2 className="text-2xl font-bold text-center mb-6">
          実際に使った人からも喜びの声!
        </h2>

        <p className="text-lg text-center mb-6">
          実際に使った人からも<br />
          <strong className="text-red-600">ポジティブなレビューが続々…!</strong>
        </p>

        <div className="mb-6">
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-start gap-4 mb-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-bold text-lg">まいさん</span>
                  <span className="text-sm text-gray-500">23歳・キャバクラ</span>
                </div>
                <div className="flex gap-1 mb-3">
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                </div>
                <p className="text-base leading-relaxed text-gray-700">
                  時給5,000円のお店からスカウトが来て、すぐに面接に行きました!前のお店より条件が良くて、スタッフさんも優しくて最高です。Nominationを使って本当に良かった♪
                </p>
              </div>
            </div>
            <div className="w-full h-56 rounded-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Young%20Japanese%20woman%20in%20her%20early%2020s%20smiling%20happily%20at%20a%20stylish%20upscale%20bar%20lounge%20with%20warm%20ambient%20lighting%20and%20elegant%20interior%20decor%20soft%20bokeh%20background%20pink%20tones%20glamorous%20nightlife%20atmosphere&width=600&height=336&seq=review1&orientation=landscape" 
                alt="まいさんのレビュー画像" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mb-6">
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex items-start gap-4 mb-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="font-bold text-lg">あやかさん</span>
                  <span className="text-sm text-gray-500">25歳・ラウンジ</span>
                </div>
                <div className="flex gap-1 mb-3">
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                  <i className="ri-star-fill text-yellow-400 text-lg"></i>
                </div>
                <p className="text-base leading-relaxed text-gray-700">
                  自分で探すのは大変だったけど、Nominationなら待ってるだけでオファーが来るから楽!しかも入店後もサポートしてくれるから安心して働けています。友達にも勧めました!
                </p>
              </div>
            </div>
            <div className="w-full h-56 rounded-lg overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Young%20Japanese%20woman%20in%20her%20mid%2020s%20relaxing%20at%20a%20luxurious%20lounge%20bar%20with%20sophisticated%20modern%20interior%20design%20soft%20warm%20lighting%20champagne%20glass%20on%20table%20elegant%20nightlife%20setting%20pink%20and%20gold%20color%20tones&width=600&height=336&seq=review2&orientation=landscape" 
                alt="あやかさんのレビュー画像" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 人気の理由セクション */}
      <section className="max-w-2xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-bold text-center mb-4">
          凄さの秘密・・・<br />
          Nominationの特徴とは!?
        </h2>

        <p className="text-lg text-center mb-8">
          こんなに愛されてるのは<strong className="text-red-600">"3つのワケ"</strong><br />
          があるみたい!!
        </p>

        {/* POINT① */}
        <div className="mb-8">
          <div className="bg-gradient-to-r from-red-500 to-pink-500 text-white py-3 px-4 rounded-t-lg">
            <p className="text-xl font-bold">
              <span className="bg-white text-red-600 px-3 py-1 rounded-full mr-2">POINT①</span>
              厳しい審査を通過した優良店舗のみオファーが届く
            </p>
          </div>
          <div className="bg-white border-2 border-red-500 p-4 rounded-b-lg mb-4">
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/317ed1c6822433dd3a33844d4d7134ab.png" 
                alt="Nomination特徴" 
                className="w-full rounded-lg shadow-md"
              />
            </div>
          </div>
        </div>

        {/* POINT② */}
        <div className="mb-8">
          <div className="bg-gradient-to-r from-red-500 to-pink-500 text-white py-3 px-4 rounded-t-lg">
            <p className="text-xl font-bold">
              <span className="bg-white text-red-600 px-3 py-1 rounded-full mr-2">POINT②</span>
              お店の条件を比べられるから理想のお店が見つかる
            </p>
          </div>
          <div className="bg-white border-2 border-red-500 p-4 rounded-b-lg mb-4">
            <div className="w-full aspect-square overflow-hidden rounded-lg">
              <img 
                src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/7b171e4d5e0faf6acf01be0a117c664b.png" 
                alt="お店の条件比較" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* POINT③ */}
        <div className="mb-8">
          <div className="bg-gradient-to-r from-red-500 to-pink-500 text-white py-3 px-4 rounded-t-lg">
            <p className="text-xl font-bold">
              <span className="bg-white text-red-600 px-3 py-1 rounded-full mr-2">POINT③</span>
              見られたくない店舗はブロック可能
            </p>
          </div>
          <div className="bg-white border-2 border-red-500 p-4 rounded-b-lg mb-4">
            <p className="text-base leading-relaxed mb-4">
              <strong>ブロックした店舗や系列からは</strong><br />
              <b>プロフィールが見れなくなるよ！</b>
            </p>
            <div className="w-full aspect-square overflow-hidden rounded-lg">
              <img 
                src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/e190e2d81e22517fd08de996efdc35ff.png" 
                alt="ブロック機能" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

      </section>

      {/* サイズ/カラー展開セクション */}
      <section className="max-w-2xl mx-auto px-4 py-6">
        <p className="text-xl font-bold text-center mb-2 text-red-600">
          入店後のサポートもあるから安心♪
        </p>

        <p className="text-base text-center mb-6">
          面接のアドバイスから入店後までサポートしてくれる!
        </p>

        <div className="space-y-4 mb-6">
          <img 
            src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/6a667dee190b291304ebfc3cadf11c7f.jpeg" 
            alt="着用例1" 
            className="w-full rounded-lg shadow-md"
          />
          <img 
            src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/06713bd9b7dfe6a59ec220673c679a83.webp" 
            alt="着用例2" 
            className="w-full rounded-lg shadow-md"
          />
          <img 
            src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/e1df05f776574e22629f8708d0bfd694.webp" 
            alt="着用例3" 
            className="w-full rounded-lg shadow-md"
          />
          <img 
            src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/36ed654ec194da679c941013f576039d.jpeg" 
            alt="着用例4" 
            className="w-full rounded-lg shadow-md"
          />
        </div>
      </section>

      {/* アンケートセクション */}
      <section id="survey" className="max-w-2xl mx-auto px-4 py-8 bg-gradient-to-b from-yellow-50 to-orange-50">
        <h2 className="text-2xl font-bold text-center mb-4">
          今すぐアンケートに回答して<br />
          無料でスカウトをGETしよう!
        </h2>

        <p className="text-lg font-bold text-center mb-4">
          今この記事を見ている方は<br />
          <span className="text-red-600 text-xl">超ラッキー!✨</span><br />
          ぜひこのまま進んでください♪
        </p>

        {/* 下矢印 */}
        <div className="flex flex-col items-center gap-2 mb-6">
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce"></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-red-500 animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>

        <div className="mb-6">
          <img 
            src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/5734821b68be27f2b511f67409bf2169.png" 
            alt="アンケート開始" 
            className="w-full"
          />
        </div>

        <p className="text-xl font-bold text-center mb-8">
          👇👇早速スタート!👇👇
        </p>

        {/* Q1 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex justify-center gap-2 mb-4">
            <span className="bg-pink-500 text-white px-3 py-1 rounded-full text-sm font-bold">01</span>
            <span className="bg-gray-300 text-gray-600 px-3 py-1 rounded-full text-sm">02</span>
            <span className="bg-gray-300 text-gray-600 px-3 py-1 rounded-full text-sm">03</span>
          </div>

          <h3 className="text-xl font-bold text-center mb-4">
            今の職場で気になる点は<br />どこですか?
          </h3>

          <div className="mb-4">
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/090755796ec3070ec909fb96b5baa07c.png" 
              alt="質問画像" 
              className="w-full rounded-lg"
            />
          </div>

          <div className="space-y-3">
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q1" className="mr-3 w-5 h-5" />
              <span className="font-bold">人間関係</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q1" className="mr-3 w-5 h-5" />
              <span className="font-bold">給料</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q1" className="mr-3 w-5 h-5" />
              <span className="font-bold">お店からの待遇</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q1" className="mr-3 w-5 h-5" />
              <span className="font-bold">客層</span>
            </label>
          </div>
        </div>

        {/* Q2 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex justify-center gap-2 mb-4">
            <span className="bg-gray-300 text-gray-600 px-3 py-1 rounded-full text-sm">01</span>
            <span className="bg-pink-500 text-white px-3 py-1 rounded-full text-sm font-bold">02</span>
            <span className="bg-gray-300 text-gray-600 px-3 py-1 rounded-full text-sm">03</span>
          </div>

          <h3 className="text-xl font-bold text-center mb-4">
            今より稼げたら<br />何にお金を使いたいですか?
          </h3>

          <div className="mb-4">
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/afa97d499441220b39ec71c7feb27f16.png" 
              alt="質問画像" 
              className="w-full rounded-lg"
            />
          </div>

          <div className="space-y-3">
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q2" className="mr-3 w-5 h-5" />
              <span className="font-bold">ブランド品を沢山買える</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q2" className="mr-3 w-5 h-5" />
              <span className="font-bold">美容や整形にお金を使える</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q2" className="mr-3 w-5 h-5" />
              <span className="font-bold">旅行に行ける</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q2" className="mr-3 w-5 h-5" />
              <span className="font-bold">推し活にお金を使える</span>
            </label>
          </div>
        </div>

        {/* Q3 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex justify-center gap-2 mb-4">
            <span className="bg-gray-300 text-gray-600 px-3 py-1 rounded-full text-sm">01</span>
            <span className="bg-gray-300 text-gray-600 px-3 py-1 rounded-full text-sm">02</span>
            <span className="bg-pink-500 text-white px-3 py-1 rounded-full text-sm font-bold">03</span>
          </div>

          <h3 className="text-xl font-bold text-center mb-4">
            Nominationの<br />特徴で一番魅力的なものは<br />なんですか?
          </h3>

          <div className="mb-4">
            <img 
              src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/7c5b9922426e10f1dfa9d34f811c0c2e.png" 
              alt="質問画像" 
              className="w-full rounded-lg"
            />
          </div>

          <div className="space-y-3 mb-4">
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q3" className="mr-3 w-5 h-5" onChange={() => setQ3Answered(true)} />
              <span className="font-bold">有名店の求人が多数</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q3" className="mr-3 w-5 h-5" onChange={() => setQ3Answered(true)} />
              <span className="font-bold">直接スカウトが貰える</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q3" className="mr-3 w-5 h-5" onChange={() => setQ3Answered(true)} />
              <span className="font-bold">時給交渉ができる</span>
            </label>
            <label className="flex items-center p-3 border-2 border-gray-300 rounded-full hover:border-red-500 hover:bg-red-50 transition cursor-pointer">
              <input type="radio" name="q3" className="mr-3 w-5 h-5" onChange={() => setQ3Answered(true)} />
              <span className="font-bold">入店後もサポートしてくれる</span>
            </label>
          </div>
        </div>

        {/* クーポン案内 - アンケート回答後に表示 */}
        <div
          ref={couponRef}
          className={`transition-all duration-700 ease-out overflow-hidden ${
            q3Answered
              ? 'opacity-100 max-h-[9999px] translate-y-0'
              : 'opacity-0 max-h-0 translate-y-8 pointer-events-none'
          }`}
        >
          <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
            <div className="mb-4">
              <img 
                src="https://storage.readdy-site.link/project_files/3733c7d9-a775-4137-85cc-35dccb60b12e/e7c280d7-8afb-451c-a253-e6774c5d48ca_85434265392e91606ed60a6cab59e7b3.png?v=dac3c5bba48ec90e87a6b157949d39dd" 
                alt="クーポン" 
                className="w-full rounded-lg"
              />
            </div>

            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/fb3bb7f79e7714bdb92032aa1ea6e5b8.png" 
                alt="登録ステップ" 
                className="w-full rounded-lg"
              />
            </div>

            <h3 className="text-xl font-bold text-center mb-6">
              カンタン3ステップで<br />優良スカウトを受け取ろう！
            </h3>

            <div className="text-center mb-4">
              <a 
                href="https://www.nomination.work/lp-new?nomipoter=bMKLNj29" 
                className="inline-block"
              >
                <img 
                  src="https://static.readdy.ai/image/c606e43a37db8bb72f8f7a401636c2e2/8b01fb8ee0883993cb2e494085efca32.png" 
                  alt="公式サイトへ" 
                  className="w-full max-w-md mx-auto animate-pulse"
                />
              </a>
              <p className="text-red-600 text-lg font-extrabold mt-2 tracking-wide">
                ※紹介料や利用料は一切なしの完全無料サービスです
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-pink-100 text-gray-700 py-8">
        <div className="max-w-2xl mx-auto px-4">
          <ul className="flex flex-wrap justify-center gap-4 mb-4 text-[7px]">
            <li>
              <span className="whitespace-nowrap">記事提供会社：株式会社RESOUND WORKS</span>
            </li>
          </ul>
          <p className="text-center text-[6px]">
            メールアドレス：info@resoundworks.co.jp
          </p>
        </div>
      </footer>
    </div>
  );
}